import { call, put, takeLatest, takeEvery } from "redux-saga/effects";
import { actions } from "./slice";
import * as API from "../../../services/apis";


export function* handleFetchCorrectionData({payload}) {
  try {
    const res = yield call(API.getCorrectionData, payload);
    const { data } = res;
    yield put(actions.fetchCorrectionDataSuccess(data));
    payload.onSuccess();
  } catch (err) {
    yield put(actions.fetchCorrectionDataFailure(err?.response?.data));
    payload.onFailure(err?.response?.data);
  }
}


export function* viewCorrectionSaga() {
    yield takeEvery(actions.fetchCorrectionData.type, handleFetchCorrectionData);
}
